// extracted by mini-css-extract-plugin
module.exports = {"spots":"SpotsLeft_spots__P6clM"};